<script>
import { POINT_MARKER_ICON_CONFIG } from "./GoogleMapSettings";

export default {
  name: "GoogleMapMarker",
  props: {
    label: {
      type: Object,
      default: undefined,
    },
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: Object,
      required: false,
      default() {
        return POINT_MARKER_ICON_CONFIG;
      },
    },
    zIndex: {
      type: Number,
      required: false,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      marker: null,
    };
  },

  watch: {
    icon: function(newVal) {
      this.marker.setIcon(newVal);
    },
    zIndex(newVal) {
      this.marker.setZIndex(newVal);
    },
  },

  mounted() {
    const { Marker } = this.google.maps;

    this.marker = new Marker({
      position: this.position,
      clickable: this.clickable,
      title: this.title,
      label: this.label,
      map: this.map,
      icon: this.icon,
      zIndex: this.zIndex,
    });

    this.$emit("initiate", this.marker);
    this.marker.addListener("click", () => this.$emit("click"));
  },
  beforeDestroy() {
    this.marker.setMap(null);
  },
  render(h) {
    return h();
  },
};
</script>
